export default "__VITE_ASSET__QUaMmhSX__"